// src/Components/LegalModal.js
import React from 'react';
import { privacyPolicy, termsOfService, refundPolicy } from '../Data/LegalDocs';

export default function LegalModal({ isOpen, onClose, docType }) {
  if (!isOpen || !docType) return null;

  const docs = {
    privacy: {
      title: 'Privacy Policy',
      content: privacyPolicy
    },
    terms: {
      title: 'Terms of Service',
      content: termsOfService
    },
    refund: {
      title: 'Refund Policy',
      content: refundPolicy
    }
  };

  const selectedDoc = docs[docType];

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-60 z-[2200] flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div 
        className="bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="sticky top-0 bg-gradient-to-r from-blue-600 to-blue-800 text-white p-6 flex items-center justify-between z-10">
          <h2 className="text-2xl font-bold">{selectedDoc.title}</h2>
          <button
            onClick={onClose}
            className="p-2 rounded-lg hover:bg-white hover:bg-opacity-20 transition-colors"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Content */}
        <div className="p-8 pb-20 overflow-y-auto max-h-[calc(90vh-100px)]">
          <div className="text-gray-700">
            <style>{`
              .legal-content h2 {
                font-size: 1.5rem;
                font-weight: 700;
                margin-top: 1.5rem;
                margin-bottom: 1rem;
                color: #1e40af;
              }
              .legal-content h3 {
                font-size: 1.25rem;
                font-weight: 600;
                margin-top: 1.25rem;
                margin-bottom: 0.75rem;
                color: #2563eb;
              }
              .legal-content p {
                margin-bottom: 1rem;
                line-height: 1.625;
              }
              .legal-content strong {
                font-weight: 600;
                color: #1f2937;
              }
              .legal-content ul, .legal-content ol {
                margin-left: 1.5rem;
                margin-bottom: 1rem;
              }
              .legal-content li {
                margin-bottom: 0.5rem;
                line-height: 1.625;
              }
              .legal-content a {
                color: #2563eb;
                text-decoration: underline;
              }
              .legal-content a:hover {
                color: #1e40af;
              }
            `}</style>
            <div 
              className="legal-content"
              dangerouslySetInnerHTML={{ __html: selectedDoc.content }}
            />
          </div>
        </div>

        {/* Footer */}
        <div className="sticky bottom-0 bg-gray-50 border-t border-gray-200 p-4 flex justify-end">
          <button
            onClick={onClose}
            className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-6 rounded-lg transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}